import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const languages = ["PL", "GB", "DE", "UA"];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  // @ts-ignore
  .init({
    fallbackLng: "PL",
    detection: {
      checkSupportedLngs: true,
      order: ["localStorage", "cookie", "path", "navigator", "htmlTag"],
      lookupLocalStorage: "i18nextLng",
      lookupCookie: "i18next",
      caches: ["localStorage", "cookie"],
    },
    debug: false,
    supportedLngs: languages,
    react: {
      useSuspense: true,
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/translation/translation_{{lng}}.json`,
      addPath: `${process.env.PUBLIC_URL}/translation/add/translation_{{lng}}`,
    },
  });

export default i18n;
